/* eslint-disable react/prop-types */
import React from 'react';
import { StyleSheet, View, ScrollView } from 'react-native';

import { isWeb, isMobileWeb, isNative } from '@global/screens';

function MenuScreen({ children }) {
  if (!isNative) {
    return <ScrollView style={styles.container}>{children}</ScrollView>;
  }
  // eslint-disable-next-line react-native/no-inline-styles
  return <View style={{ flex: 1 }}>{children}</View>;
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    height: '100%',
    flex: 1,
    padding: isWeb ? 30 : 0,
    overflow: isWeb && !isMobileWeb ? 'scroll' : 'hidden',
  },
});

export default MenuScreen;
